module.exports = __webpack_public_path__ + "static/media/banner4.1979cc11.jpg";